import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]




export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLineTool',
  props: {
    iconId: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "DocumentLineTool",
    title: __props.title
  }, [
    _createElementVNode("i", {
      class: _normalizeClass('fa fa-' + __props.iconId)
    }, null, 2)
  ], 8, _hoisted_1))
}
}

})